import { getStore } from '../store/store';

export function isAttachmentFolderSelectorOpen() {
    return getStore().isOpen;
}
